import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";

import { DRIVER_TYPE_NAMES } from "../../consts/driverTypes";
import { palette } from "../../theme/palette";

import { LeafIcon } from "../Icons";
import { View } from "../View";
import { TextIconInfo } from "../RouteCard/TextIconInfo";

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    marginTop: "-0.2rem",
    marginLeft: "1.2rem",
    gap: "0.5rem",
  },
  left: {
    display: "flex",
    flexDirection: "column",
  },
  right: {
    display: "flex",
    flexDirection: "column",
  },
  row: {
    display: "flex",
    height: "1.25rem",
  },
  leftRow: {
    justifyContent: "flex-end",
  },
  rightRow: {
    justifyContent: "flex-start",
  },
  iconRow: {
    marginTop: "-0.25rem",
  },
  text: {
    fontSize: "12px",
    color: palette.typography.white.high,
    lineHeight: "16px",
  },
  space: {
    width: "12px",
  },
});

export const DriverCardProfileContent = ({ driver, vehicle }) => {
  const styles = useStyles();

  return (
    <View className={clsx(styles.container, styles.text)}>
      <View className={styles.left}>
        <View className={clsx(styles.row, styles.leftRow)}>{`Photo`}</View>
        <View className={clsx(styles.row, styles.leftRow)}>{`Type`}</View>
        <View
          className={clsx(styles.row, styles.leftRow)}
        >{`Phone Number`}</View>
        <View className={clsx(styles.row, styles.leftRow)}>{`Vehicle`}</View>
      </View>
      <View className={styles.right}>
        <View className={clsx(styles.row, styles.rightRow)}>{`${
          !!driver.photoCode ? "Yes" : "No"
        }`}</View>
        <View className={clsx(styles.row, styles.rightRow)}>{`${
          DRIVER_TYPE_NAMES[driver.driverType]
        }`}</View>
        <View className={clsx(styles.row, styles.rightRow)}>{`${
          driver.phoneNumber || ""
        }`}</View>
        <View className={clsx(styles.row, styles.rightRow, styles.iconRow)}>
          <TextIconInfo
            keyName={""}
            value={vehicle?.description}
            icon={vehicle?.electricVehicle && <LeafIcon />}
          />
        </View>
      </View>
    </View>
  );
};
